import { useQuery } from '@tanstack/react-query';
import {
  getPlatformStatsForDomain,
  PlatformStatsForDomainResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

const GET_PLATFORM_STATS_FOR_DOMAIN = 'platform-stats-for-domain';

export const useGetPlatformStatsForDomain = (
  projectId: number,
  domain: string,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!domain && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const { data: platformStats, isLoading } = useQuery<PlatformStatsForDomainResponse>({
    queryKey: [GET_PLATFORM_STATS_FOR_DOMAIN, projectId, domain, chatType, fromTimestamp, toTimestamp, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getPlatformStatsForDomain(projectId, domain, chatType!, from, to, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    platformStats: queryEnabled ? platformStats ?? null : null,
    isLoading: queryEnabled ? isLoading : false,
  };
};
